export enum SettingsRoute {
  Metrics = 'Metrics',
  MasterProgram = 'Master program',
  Supports = 'Supports',
  Activities = 'Activities',
  UserManagement = 'User management',
  Assessments = 'Assessments',
}

export enum CreditsRoute {
  Credits = 'Credits',
  Regents = 'Regents',
  GradPlanning = 'Grad Planning',
}

export enum SupportsRoute {
  AllSupports = 'All Supports',
  SupportRosters = 'Support Rosters',
  SupportAttendance = 'Support Attendance',
}

export const SettingsRoutesStates = {
  Metrics: 'main.school.settings.metrics.credits',
  'Master program': 'main.school.settings.master-program',
  Supports: 'main.school.settings.supports.all-supports',
  Assessments: 'main.school.settings.assessments',
  Activities: 'main.school.settings.activities',
  'User management': 'main.school.settings.user-management',
};
